import { CustomErrorType } from "../interfaces/CustomErrorType";

export default {
    code: 'ERR_EMAIL_SENT',
    statusCode: 400,
    message: {
        en: 'Mail has been sent',
    },
} as CustomErrorType;